import * as S from "./styles";

export function Loader() {
  return <S.Container />;
}
